import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'findById',
    standalone: true
})
export class FindByIdPipe implements PipeTransform {
  transform<T extends { id: IDType }, IDType = string>(items: T[], id: IDType): T {
    return items.find(item => item.id === id)
  }
}

@Pipe({
    name: 'findByProp',
    standalone: true
}) // can find by any prop that leads to a certain type, for example ossView | findByProp:mobileScheduleId:scheduleId, where ossView.scheduleId is a string and mobileScheduleId is a string
export class FindByPropPipe implements PipeTransform {
  transform<T, P extends keyof T>(items: T[], id: T[P], p: P): T {
    return items.find(item => item[p] === id)
  }
}



